import {deepCopy} from "@common/ObjectsHelper";
import {DateTime} from "luxon";

export class ObjectResetter {
   private copy: any = null;
   needToReset = false;

   constructor(private source: any) {
       this.doCopy();
   }

   doCopy() {
       this.copy = deepCopy(this.source);
   }

   private copyValue(source: any, value: any) {
       if (Array.isArray(value)) {
           const newArray = new Array(value.length);
           for(let i = 0, len = value.length; i < len; i++) {
               newArray[i] = this.copyValue(source[i], value[i])
           }
           return newArray;
       }

       if (value instanceof Date) {
           return new Date(value.getTime()) as any;
       }

       if (value instanceof DateTime || source == null) {
           return value;
       }

       if (value && typeof value === 'object') {
           Object.keys(value).forEach(valueKey => {
               source[valueKey] = this.copyValue(source[valueKey], value[valueKey]);
           });
           return source;
       }

       return value;
   }

   reset() {
     if (!this.needToReset) { return; }

     this.source = this.copyValue(this.source, this.copy);
     this.needToReset = false;
   }
}
